export const apiBaseUrl = "";
export const prod =
  process.env.NODE_ENV === "production" && !(window as any).debug;
